import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaMagnifyingGlass } from "react-icons/fa6";
import api from '../../api/manage_database/LocationReq';
import SelectLocation from '../../components/SelectLocation';
import BackButton from "../../components/BackButton";
import { toast } from 'sonner';


const LocationChoice = () => {

    const [Locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState('');
    
    const navigate = useNavigate();

    const handleView = () => {
        if (selectedLocation === '') {
            toast.error('Choose available location!')
            return
        } else {
            navigate(`../record/${selectedLocation}`)
        }
    }

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setLocations(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
                
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchLocations();
    }, []);

    return (
        <div className='location-choice-container'>
            <h2 className='location-choice-title'>Location</h2>
            <div className='location-choice-card'>
                <div className='location-choice-label-select-wrapper'>
                    <label
                        htmlFor='location-select'
                        className='bold-label'
                    >
                        Location:
                    </label>
                    <SelectLocation
                        Locations={Locations}
                        selectedLocation={selectedLocation}
                        setSelectedLocation={setSelectedLocation}
                    />
                </div>
                <button
                    className='location-choice-button'
                    onClick={handleView}>View &nbsp; <FaMagnifyingGlass /></button>
            </div>
            <BackButton navigateTo='/manage-database'/>
        </div>
    );
        
};

export default LocationChoice;